import { Col, Container, Row, Spinner } from "react-bootstrap";
import { BsDownload } from "react-icons/bs";
import "./documentList.css";
import Humanize from "humanize-plus";
import FileTypeIcon from "../../components/filetypeIcon";
import { useEffect, useState } from "react";
import PaginationPanel from "../../components/paginations/paginationPanel";
import { Document, Criteria, DocumentSortMethod } from "../../models/document";
import apiService from "../../services/ApiService";
import Constants from "../../helpers/Constants";
import AppSettings from "../../configs/appSettings";
import { useParams } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import SortingDropdown from "../../components/dropdowns/documents/sortMethod/sortMethodDropDown";
import  { useDebounce }  from "../../Utils/index";

const DocumentList = () => {
  const { category } = useParams();
  const initPageData: Document = {
    files: [],
    itemCount: 0,
    pageCount: 0,
    category: { name: "", description: "" },
  };
  const [pageData, setPageData] = useState(initPageData);




  const initCriteria: Criteria = {
    keyword: "",
    category: category ?? "logos",
    page: 1,
    sku: "",
    display: "list",
    sortMethod:Object.keys(DocumentSortMethod).indexOf(DocumentSortMethod.MostRecent.replace(' ',''))

  };
  const [criteria, setCriteria] = useState(initCriteria);
  const debounceValue = useDebounce(criteria.keyword,2000);

  const handleSearchBarChange=(val:string)=>{
    
    if(!!val) setCriteria({...criteria, keyword:val});
  }
  const handleSortOptionChange=(val:DocumentSortMethod)=>{
    setCriteria({...criteria, sortMethod:Object.keys(DocumentSortMethod).indexOf(val.replaceAll(' ',''))});
  }

  const handlePageIndexChange = (value: number) => {
    setPageData((prevValue) => {
      return { ...prevValue, files: [] };
    });
    setCriteria((prevValue) => {
      return { ...prevValue, page: value };
    });
  };

  const [isLoading, setIsLoading] = useState(true);
  const [isFiltering, setIsFiltering] = useState(false);
  useEffect(() => {
    
    setIsFiltering(true);
    apiService
      .get(`${Constants.ApiPath.DocumentPage}`, criteria)
      .then((result) => {
        if (result) {
          setIsLoading(false);
          setIsFiltering(false);
          setPageData(result.data);
        }
      });
  }, [category, criteria.page, debounceValue,criteria.sortMethod]);

  const [selected, setSelected] = useState<string[]>([]);

  const handleSelectAll = (event: any) => {
    const data: string[] = event.target.checked
      ? pageData.files.map((f) => f.id)
      : [];
    setSelected(data);
  };

  const handleSelectOne = (event: any) => {
    setSelected((prevValue) => {
      const id = event.target.value;
      const data: string[] = event.target.checked
        ? [...prevValue, id]
        : prevValue.filter((p) => p !== id);
      return data;
    });
  };


  const downloadFile = (ids: string[]) => {
    if (ids.length < 1) return;
    apiService
      .get(
        Constants.ApiPath.DocumentGenerate,
        { ids },
        { Accept: "text/plain" }
      )
      .then((result) => {
        const url = `${AppSettings.ApiBaseUrl}/${
          Constants.ApiPath.DocumentDownload
        }?code=${encodeURIComponent(result.data)}`;
        window.location.href = url;
      });
  };

  return isLoading ? (
    <Container className="category-page-loading">
      <div>
        <Spinner animation="border" />
        <p>Loading...</p>
      </div>
    </Container>
  ) : (
    <>
      {isFiltering && (
        <Container className="category-page-filtering" fluid>
          <div>
            <Spinner animation="border" />
            <p>Loading...</p>
          </div>
        </Container>
      )}
      <Container className="document-page-header">
        <label>{pageData.category.name}</label>
        <Row className="pt-3">
            <div className="col-3">
                <div className="round-search-input">
                  <FaSearch color="white" className="icon" />
                  <input
                    type="text"
                    placeholder="Document Name"
                    onChange={(e) => {handleSearchBarChange(e.target.value)}}
                  />
                </div>
              </div>       
              <span className="col-1 pt-1 text-end"><strong>Sort By</strong></span>
              <div className="col-3">        
                <SortingDropdown selectedValue={Object.values(DocumentSortMethod)[criteria.sortMethod]} onSelected={handleSortOptionChange}>
                </SortingDropdown>
            </div>
      </Row>
      </Container>
      <Container className="document-page-list">
        <Row className="document-page-list-header">
          <Col sm={6} xxl={8} xl={6} className="document-page-list-header-name">
            <label>NAME</label>
          </Col>
          <Col sm={1} className="document-page-list-header-size">
            <label>SIZE</label>
          </Col>
          <Col sm={1} xs={8} className="document-page-list-header-download">
            <span
              onClick={() => downloadFile(selected)}
              title="DOWNLOAD DOCUMENTS"
            >
              <BsDownload />
            </span>
          </Col>
          <Col sm={3} xs={4} className="document-page-list-header-action">
            <label htmlFor="chkSelectAll">Select All</label>
            <input
              type="checkbox"
              id="chkSelectAll"
              onChange={handleSelectAll}
            />
          </Col>
        </Row>
        {pageData.files.map((document) => {
          const isSelected =
            selected.findIndex((id) => id === document.id) >= 0;
          const size = Humanize.fileSize(document.size);
          return (
            <Row className="document-page-list-items" key={document.id}>
              <Col className="document-page-list-items-icon">
                <FileTypeIcon extension={document.extension} />
              </Col>
              <Col
                sm={6}
                xxl={8}
                xl={6}
                xs={9}
                className="document-page-list-items-name"
              >
                <div className="document-page-list-icon">
                  <FileTypeIcon extension={document.extension} />
                </div>
                <div className="document-page-list-name">{document.name}</div>
                <div className="document-page-list-size">{size}</div>
              </Col>
              <Col sm={1} className="document-page-list-items-size">
                <label>{size}</label>
              </Col>
              <Col sm={1} className="document-page-list-items-download">
                <span onClick={() => downloadFile([document.id])}>
                  <BsDownload />
                </span>
              </Col>
              <Col sm={3} xs={1} className="document-page-list-items-action">
                <input
                  type="checkbox"
                  value={document.id}
                  onChange={handleSelectOne}
                  checked={isSelected}
                />
              </Col>
            </Row>
          );
        })}
      </Container>
      <Container className="document-page-pagination-container">
        <PaginationPanel
          pageCount={pageData.pageCount}
          pageIndex={criteria.page}
          onPageIndexChange={(val) => handlePageIndexChange(val)}
        />
      </Container>
    </>
  );
};

export default DocumentList;
